// uncomment the wdyr import to enable why-did-you-render
// import '@/wdyr'; // Note this must be the first import for it to work
import '@/styles';
import momentDurationFormatSetup from 'moment-duration-format';
import moment from 'moment-timezone';
import { createRoot } from 'react-dom/client';
import { patchGlobalResizeObserver } from '@/core/PatchedResizeObserver';
import { isSystemTest } from '@/core/utilities';
import { Application } from '@/main/Application.page';
import { headlessRenderMode } from '@/services/headlessCapture.utilities';

// Patch ResizeObserver before any components are created
// This ensures all ResizeObserver instances (including those created during initial render)
// are wrapped to prevent "loop completed with undelivered notifications" errors
patchGlobalResizeObserver();

if (!Array.prototype.uniqBy) {
  Array.prototype.uniqBy = function <T>(this: Array<T>, callback: (item: T) => any): Array<T> {
    const seenValues = new Set<any>();

    return this.filter((item) => {
      const callbackValue = callback(item);
      if (seenValues.has(callbackValue)) {
        return false;
      }

      seenValues.add(callbackValue);

      return true;
    });
  };
}

// https://github.com/seeq12/crab/pull/5962/files#r1446538620
momentDurationFormatSetup(moment as any);

const rootEl = document.getElementById('sqApp') || document.createElement('div');
if (isSystemTest() || headlessRenderMode()) {
  rootEl.classList.add('isHeadlessMode');
}
const root = createRoot(rootEl);
root.render(<Application />);
